import { JsonObject } from '@bufbuild/protobuf';
import { ReaperSettings } from '@q6cyber/proto2es/generated/client';

import { FormControl, Validators } from '@angular/forms';

import { RouterOutput } from '../../../utils';
import { customFormGroup } from '../utilities';

export type AutomatedPurchaseListResponse =
  RouterOutput['cardAutomatedPurchase']['list']['edges'][0];

export const DEFAULT_REAPER_SETTINGS = new ReaperSettings().toJson({
  emitDefaultValues: true,
}) as JsonObject;

export const automatedPurchaseForm = () => {
  const form = customFormGroup({
    budget: new FormControl(0, [Validators.min(0), Validators.max(9999)]),
    supportsAutomatedPurchase: new FormControl(false),
    active: new FormControl(false),
    cycleLength: new FormControl(0),
    defaultFetchIntervalMin: new FormControl(0),
    maxAgePerBase: new FormControl(0, [Validators.min(0), Validators.max(99)]),
    maxCardPrice: new FormControl(0, [Validators.min(0), Validators.max(99)]),
    maxCardsPerBase: new FormControl(0, [
      Validators.min(0),
      Validators.max(99),
    ]),
    minAgePerBase: new FormControl(0, [Validators.min(0), Validators.max(99)]),
    minCardPrice: new FormControl(0, [Validators.min(0), Validators.max(99)]),
    minCardsPerBase: new FormControl(0, [
      Validators.min(0),
      Validators.max(99),
    ]),
    collectionPriority: new FormControl(0),
    autopurchasePriority: new FormControl(0),
    blacklistQueryString: new FormControl(''),
    typePreference: new FormControl(null as string | null),
    checkBasesValidity: new FormControl(false),
    excludedShopsCvv: new FormControl<string[]>([], {
      nonNullable: true,
    }),
    excludedShopsDump: new FormControl<string[]>([], {
      nonNullable: true,
    }),
  });

  return form;
};
